import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { IncassoSoggetto } from 'src/app/common/models/incasso-soggetto';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Incasso } from '../../../models/incasso';
import { SezioneIncassi } from '../../../models/sezioni/sezione-incassi';
import { IncassiRipartizioneComponent } from './incassi-ripartizione.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [incasso-mod-ripartizione]',
  templateUrl: 'incasso-mod-ripartizione.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class IncassoModRipartizione {
  @Output() onReturn: EventEmitter<SezioneIncassi> = new EventEmitter<SezioneIncassi>();
  @ViewChild('formIncassoRipartizione') formIncassoRipartizione: IncassiRipartizioneComponent;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(sezione: SezioneIncassi, incasso: Incasso, urlUpdate: string, fascicolo: FascicoloFull, inserimento: boolean, ripartizione?: IncassoSoggetto) {
   this.formIncassoRipartizione.inizializza(sezione, incasso, urlUpdate, fascicolo, inserimento, ripartizione);
    openModal('modalRipartizioneIncasso');
  }

  createForm() {
    this.formIncassoRipartizione.createForm();
  }

  manageModal(sezioneIncassi: SezioneIncassi) {
      closeModal('modalRipartizioneIncasso');
      this.onReturn.emit(sezioneIncassi);
  }
}
